import { render, staticRenderFns } from "./PeriodoVigenciaSetting.vue?vue&type=template&id=44c58052"
import script from "./PeriodoVigenciaSetting.vue?vue&type=script&lang=js"
export * from "./PeriodoVigenciaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports